// import runtimeEnv from '@mars/heroku-js-runtime-env';

// function getHerokuEnvironmentVariables() {
//     // Read Heroku environment variables
//     const environmentVariables = runtimeEnv();

//     if (!Object.keys(environmentVariables).length) {
//         // eslint-disable-next-line no-console
//         console.warn('Make sure you\'ve got REACT_APP_BUILDTIME_APP_ENV env variable set if you\'re running build localy.');
//     }

//     return environmentVariables;
// }

// function getEnvironmentVariables() {
//     // eslint-disable-next-line import/no-mutable-exports
//     let environmentVariables;

//     if (process.env.REACT_APP_BUILDTIME_APP_ENV === 'local') {
//         // Get local environment variables
//         environmentVariables = process.env;
//     } else {
//         environmentVariables = getHerokuEnvironmentVariables();
//     }

//     return environmentVariables;
// }

function getEnvironmentVariables() {
  let environmentVariables = process.env;
  console.log("process.env;", environmentVariables);

  return environmentVariables;
}

export default getEnvironmentVariables();
